import React from 'react';
import {IHandlers, IProps} from './types';
import style from './style.module.scss';
import ChildMenuOptionImplicitList from "shared-components/booking-options-section/ChildMenuOptionImplicitList";
import {wrapperStyleType, IBookingMenuOption} from "shared-types/index";

const NS = 'UpsellMenuOptions';

export default function UpsellMenuOptions({theme, menuOptionsImplicit, currency, selectedMenuOptions, handleUpsellUpdate}: IProps & IHandlers) {

  const gridXs = 12;
  const gridSm = 6;
  const gridMd = 4;
  const gridLg = 3;
  const gridGutter = 2;

  return (
    <div className={style.root}>
      <ChildMenuOptionImplicitList
        wrapperStyle={wrapperStyleType.standard}
        menuOptions={menuOptionsImplicit}
        theme={theme}
        currency={currency}
        gridSizes={[gridXs, gridSm, gridMd, gridLg]}
        gridGutter={gridGutter}
        selectedMenuOptions={selectedMenuOptions}
        handleSpinnerUpdate={(selectedMenuOptions: IBookingMenuOption[]) => {
          const selectUpsellData: IBookingMenuOption[] = selectedMenuOptions.map((s) => {
            s.isUpsellItem = true;
            return s;
          });
          handleUpsellUpdate(selectUpsellData);
        }} />
    </div>
  )
}

